export default __webpack_public_path__ + "static/media/bateriaback.1b3cd81c.png";